import React, { useEffect } from "react";
import "./TagsDisplayControl.css";
import { X } from "react-feather";

export const TagsDisplayControl = ({ tags, onTagClick, onTagRemoved }) => {
    return (
        <div className="tags-display-control">
            {tags &&
                tags.length > 0 &&
                tags.map(function (tag, idx) {
                    return (
                        <div
                            className={`tag ${onTagClick != null ? "clickable" : "readonly"}`}
                            key={`tag_${idx}`}
                            onClick={() => {
                                if (onTagClick) {
                                    onTagClick(tag);
                                }
                            }}
                        >
                            {tag.name}
                            {/* {<div className="tag">{tag.name}</div>} */}
                            {onTagRemoved != null ? (
                                <div className="remove" onClick={(e) => onTagRemoved(tag)}>
                                    <X />
                                </div>
                            ) : (
                                ""
                            )}
                        </div>
                    );
                })}
        </div>
    );
};
